import React from 'react';

const Hypothermia = () => {
  return (
    <div>
      <h1>HYPOTHERMIA</h1>
      <h3>Dr Mind</h3>
      <h3>Dr Body</h3>
      <h3>Dr Eye</h3>
      <img
        src="/blog-hypothermia.png"
        alt="Screen Shot 2020-04-27 at 2.36.07 pm"
      />
      <h4>What is hypothermia?</h4>
      <ul>
        <li>Hypothermia is defined as a body core temperature less than 35 C.</li>
        <li>
          Decreased consciousness occurs when the core temperature falls to
          approximately 32 to 30 C.
        </li>
        <li>Normal body temperature is 37.2 C</li>
      </ul>
      <h4>Who is at risk for developing hypothermia?</h4>
      <ul>
        <li>WE ALL ARE!!! BUT particularly…. people under 16 and over 65</li>
        <li>
          Alcohol use: alcohol makes you feel warm inside, but causes blood
          vessels to dilate, causing increased heat loss, and can upset
          thermoregulation
        </li>
        <li>
          Medical illnesses: that affect sensation in extremities eg feet and
          medications
        </li>
        <li>Dehydration and jetlag</li>
      </ul>
      <h4>Swimming in cold water</h4>
      <ul>
        <li>
          In cold water, heat is conducted away from the body and transferred
          to the water.
        </li>
        <li>
          Heat is lost very quickly, 25 to 30 times faster in water than air.
        </li>
        <li>
          Swimming ie activity further increases heat loss (increase by 35-50%)
        </li>
      </ul>
      <h4>How long can a person survive in cold water?</h4>
      <table>
        <thead>
          <tr>
            <th>Water temp</th>
            <th>Exhaustion</th>
            <th>Survival</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>4C-10C</td>
            <td>30 to 60 min</td>
            <td>1 to 3 hrs</td>
          </tr>
          <tr>
            <td>10C-15C</td>
            <td>1 to 2 hrs</td>
            <td>1 to 6 hrs</td>
          </tr>
          <tr>
            <td>15C-21C</td>
            <td>2 to 7 hrs</td>
            <td>2 to 40hrs</td>
          </tr>
        </tbody>
      </table>
      <h4>Hypothermia symptoms</h4>
      <ul>
        <li>shivering</li>
        <li>clumsiness or lack of co-ordination</li>
        <li>slurred speech or mumbling</li>
        <li>confusion or difficulty thinking</li>
        <li>poor decision making lack of concern about one’s condition</li>
        <li>weak pulse '</li>
        <li>shallow breathing</li>
      </ul>
      <h4>Swim Failure:</h4>
      <ul>
        <li>
          Swim failure occurs when the arm muscles are cooled to the point they
          cease working properly
        </li>
        <li>Children and thin adults are vulnerable</li>
        <li>Another good reason never to swim alone!</li>
      </ul>
      <h4>Symptoms:</h4>
      <ul>
        <li>
          Hypothermia sneaks up on you, so you probably aren't the best judge of
          whether or not you are hypothermic.
        </li>
        <li>Self awareness is your greatest asset.</li>
        <li>
          Resisting help and acting irrational or confused are common indicators
          of hypothermia.
        </li>
        <li>
          As your core temperature drops dangerously low, you become
          semiconscious, then unconscious.
        </li>
        <li>
          Low core body temperatures may cause cardiac and respiratory failure
        </li>
      </ul>
      <h4>Prevention:</h4>
      <ul>
        <li>Have a hot drink before leaving home</li>
        <li>
          When leaving home Pack an old jacket/sweater and shoes/sandals and
          WEAR them.
        </li>
        <li>
          Heat loss occurs in cold air and it is important to be warm before
          entering the water.
        </li>
        <li>
          Consider if you should swim today, (the café is always a safe and
          social option)
        </li>
        <li>Consider how long you should swim today</li>
        <li>Consider who you will swim with (always swim with others ).</li>
        <li>Ask yourself: do I feel well?</li>
        <li>Ask yourself: did I have a big night last night?</li>
        <li>
          Ask yourself: how did I feel after my last swim? Is it colder? Is it
          rougher?
        </li>
        <li>Ask yourself: how many min. can I swim for in winter? Swim within
          yourself.
        </li>
        <li>
          Wear a jacket/sweater and shoes on the pier as cold air and wind
          cause significant heat loss
        </li>
        <li>If you don’t feel right GET OUT</li>
      </ul>
      <h4>When trouble strikes</h4>
      <p>If you suspect you are developing swim failure or hypothermia:</p>
      <ul>
        <li>Tell someone</li>
        <li>Try to stand up if the water is shallow</li>
        <li>
          Use your legs as they don’t cool, as quickly as your arms and kick to
          land/platform /board
        </li>
      </ul>
      <h4>Signs:</h4>
      <ul>
        <li>Severely hypothermic people have icy skin.</li>
        <li>
          Extreme lethargy merges with unconsciousness and they might appear
          dead.
        </li>
        <li>
          Since each individual reacts differently, the severity of hypothermia
          is best measured by taking a core temperature reading using a rectal
          thermometer
        </li>
      </ul>
      <h4>Treating hypothermia</h4>
      <ul>
        <li>Be gentle and limit movements to only those which are necessary</li>
        <li>
          Get the person indoors to the steam room ASAP and dry them gently
          with a towel
        </li>
        <li>Lie the person down in the steam room</li>
        <li>
          Monitor breathing, pulse and brain eg Ask the person questions eg
          where are you? what day is it?
        </li>
        <li>
          Share body heat to the chest, warm the core, place warm arms across
          the chest
        </li>
        <li>Provide a warm drink</li>
        <li>DO NOT massage or rub the person</li>
        <li>DO NOT apply direct heat eg a hot shower</li>
        <li>
          Heat applied to the arms and legs forces cold blood back to the
          heart and lowers the temperature further.
        </li>
        <li>
          DO NOT leave the person alone if No pulse or Not breathing then CPR
          (Try for 2 min to find pulse , breathing)
        </li>
        <li>CALL AN AMBULANCE</li>
        <li>
          Don't assume the person is dead, they are only dead when they are
          warm and dead.
        </li>
      </ul>
      <p><strong>Good luck to all !!!!! Safe winter swimming. “Be alert but not
        alarmed”</strong>
      </p>
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default Hypothermia;
